import { z } from 'zod';

/**
 * P2 — Todo en milimetros sobre la zona de marcaje. El pixel es una unidad de
 * pantalla, no de produccion. Este alias existe para que el tipo lo recuerde.
 */
export const Millimeters = z.number().finite();
export type Millimeters = z.infer<typeof Millimeters>;

/** Punto en el sistema de coordenadas de la zona de marcaje, en mm. */
export const PointMm = z.object({ x: Millimeters, y: Millimeters });
export type PointMm = z.infer<typeof PointMm>;

/**
 * Matriz afin [a b c d e f]. `e`/`f` son la traslacion, en MILIMETROS.
 * Permite escalado no uniforme y espejado (a/d negativos), a diferencia de
 * guardar "rotacion + escala", que no puede representar un espejado.
 */
export const AffineMatrix = z.object({
  a: z.number().finite(),
  b: z.number().finite(),
  c: z.number().finite(),
  d: z.number().finite(),
  e: Millimeters,
  f: Millimeters,
});
export type AffineMatrix = z.infer<typeof AffineMatrix>;

export const IDENTITY_MATRIX: AffineMatrix = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 };

/** Checksum de contenido: `sha256:<64 hex>`. Los assets se referencian asi, nunca por ruta. */
export const Checksum = z
  .string()
  .regex(/^sha256:[0-9a-f]{64}$/, 'checksum debe ser sha256:<64 hex>');
export type Checksum = z.infer<typeof Checksum>;

export const Uuid = z.string().uuid();
